import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import NextButtonImage from '../../../../image/NormalNextInfoButton.png';
import ColorPrevButtonImage from '../../../../image/ColorPrevInfoButton.png';
import ColorNextButtonImage from '../../../../image/ColorNextInfoButton.png';

const SecondMemberShipHistoryColumn = (props) => {
  const { isOver, prevFn, nextFn } = props;

  return (
    <TopLevelWrapper isOver={isOver}>
      {
        isOver ?
          <ColumnWrapper>
            <Column style={{ marginRight: 'max(65px, 8.463541666666667vw)', marginLeft: 'max(28px, 3.645833333333333vw)' }} isOver={isOver}>카드</Column>
            <Column style={{ marginRight: 'max(65px, 8.463541666666667vw)' }} isOver={isOver}>현금</Column>
            <Column style={{ marginRight: 'max(52px, 6.770833333333333vw)' }} isOver={isOver}>미수금</Column>
            <Column style={{ marginRight: 'max(49px, 6.380208333333333vw)' }} isOver={isOver}>결제일</Column>
            <Column style={{ marginRight: 'max(109px, 14.19270833333333vw)' }} isOver={isOver}>남은 일수</Column>
          </ColumnWrapper>
          :
          <ColumnWrapper>
            <Column style={{ marginRight: 'max(18px, 5.625vw)', marginLeft: 'max(4px, 1.25vw)' }} isOver={isOver}>수강횟수</Column>
            <Column style={{ marginRight: 'max(12px, 3.75vw)' }} isOver={isOver}>결제 금액</Column>
            <Column style={{ marginRight: 'max(34px, 10.625vw)' }} isOver={isOver}>카드</Column>
            <Column isOver={isOver}>현금</Column>
          </ColumnWrapper>
      }
      {
        isOver ?
          <ButtonWrapper isOver={isOver}>
            <Button src={ColorPrevButtonImage} isOver={isOver} onClick={prevFn} />
            <Column isOver={isOver}>이전 정보</Column>
            <Button src={NextButtonImage}  isOver={isOver}/>
          </ButtonWrapper>
          :
          <ButtonWrapper isOver={isOver}>
            <Button src={ColorPrevButtonImage} isOver={isOver} onClick={prevFn} />
            <Button src={ColorNextButtonImage} isOver={isOver} onClick={nextFn} />
          </ButtonWrapper>
      }
    </TopLevelWrapper>
  )
}

export default SecondMemberShipHistoryColumn;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: ${props => props.isOver ? `34px` : `23px`};
  margin-bottom: ${props => props.isOver ? `18px` : `15px`};

  // width: ${props => props.isOver ? `` : `max(262px, 81.875vw)`};
  width: ${props => props.isOver ? `max(664px, 86.45833333333333vw)` : `max(268px, 83.75vw)`};
  
  transition: all 0.3s ease-in-out;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: ${props => props.isOver ? `4px` : `6px`};
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `14px` : `10px`};

  color: #232323;

  margin: 0 0 0 0;
`;

const Button = styled.img`
  width: ${props => props.isOver ? `24px` : `15px`};
  height: ${props => props.isOver ? `24px` : `15px`};

  border-radius: ${props => props.isOver ? `24px` : `15px`};

  &:hover {
    cursor: pointer;
  }
`;